
<template>

  <svg viewBox="0 0 134.753 62.4909" aria-hidden="true">

    <g transform="translate(-47.8596 -12.1045)" fill="currentColor">

      <path d="m142.967 38.9194c0-10.7072-8.78534-10.2929-13.9166-16.4823-5.13124-6.18944-8.31828-10.3326-13.814-10.3326s-8.68277 4.14311-13.814 10.3326c-5.13123 6.18944-13.9166 5.77515-13.9166 16.4823z" />

      <path d="m115.236 46.9196a67.3766 13.8379 0 0 0-67.3762 13.8379 67.3766 13.8379 0 0 0 67.3762 13.8379 67.3766 13.8379 0 0 0 67.3768-13.8379 67.3766 13.8379 0 0 0-67.3768-13.8379zm0 9.90586a33.1638 6.84263 0 0 1 33.1639 6.84248 33.1638 6.84263 0 0 1-33.1639 6.84299 33.1638 6.84263 0 0 1-33.1639-6.84299 33.1638 6.84263 0 0 1 33.1639-6.84248z" />

    </g>

  </svg>

</template>
